import OnBirMatematik from "../pages/matematik/class11/OnBirMatematik";

export const Matematik11 = [
  {
    path: "/matematik/11-sinif",
    element: <OnBirMatematik activeDivProps={1} />
  }
];

